import styled from '@emotion/styled';

const CardSmallInfo = styled('div')({
  float: 'left',
  marginTop: '.3rem',
  width: 'calc(100% - 10rem)',
});

export default CardSmallInfo;
